import { DraggableScroll } from "@/components/common/DraggableScroll";
import { LoadingSkeleton } from "@/components/common/LoadingSkeleton";
import { ComponentType } from "@/interfaces/common";
import clsx from "clsx";
import { TableHTMLAttributes } from "react";
import { TableBody } from "../TableBody";
import { TableHeader } from "../TableHeader";

type Props = Readonly<
  TableHTMLAttributes<HTMLTableElement> & {
    children: [ComponentType<typeof TableHeader>, ComponentType<typeof TableBody>];
    isLoading?: boolean;

    /**
     * Se habilitado, a tabela pode ser rolada com o atalho de `Espaço + Arrastar`.
     * @note Avaliando a utilidade e possibilidade de tornar esse comportamento padrão futuramente.
     */
    dragScroll?: boolean;
  }
>;

export const TableContent = ({ children, className, isLoading = false, dragScroll = false, ...props }: Props) => {
  const content = (
    <div className={clsx("relative w-full", { "overflow-x-auto": !dragScroll })}>
      <table className={clsx("w-full", className)} {...props}>
        {children}
      </table>

      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-background-primary/70 backdrop-blur-[1px]">
          <LoadingSkeleton kind="absolute" className="rounded-none" />
        </div>
      )}
    </div>
  );

  if (dragScroll) {
    return <DraggableScroll>{content}</DraggableScroll>;
  }

  return content;
};
